/**
 * Haptics — a subtle confirmation buzz on key actions (DESIGN.md feel notes).
 * No-op on devices/browsers without the Vibration API (most desktops, iOS
 * Safari currently), so it is always safe to call.
 */
export function buzz(ms = 14) {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    navigator.vibrate(ms);
  }
}
